import { render } from "./EditedOrderLinksPage.vue?vue&type=template&id=025c8f91&scoped=true"
import script from "./EditedOrderLinksPage.vue?vue&type=script&lang=js"
export * from "./EditedOrderLinksPage.vue?vue&type=script&lang=js"

import "./EditedOrderLinksPage.vue?vue&type=style&index=0&id=025c8f91&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025c8f91"]])

export default __exports__